// extracted by mini-css-extract-plugin
export default {"code":"Vw7AhpAH","title":"J_FjH5zW"};